<template>
  <v-container
    data-vue-component-name="MouseButtonTest"
    fill-height
    fluid
    class="align-start pa-16"
    @click.self="logger($event, 'Whitespace', false)"
    @contextmenu.prevent.self="logger($event, 'Whitespace', false)"
  >
    <v-row class="flex-column events-none" align="center">
      <h3 class="font-weight-bold mb-2">{{ getExerciseTitle }}</h3>
      <progress-bar :value="progress" />
    </v-row>

    <v-row justify="center" class="space-x-15 events-none">
      <v-btn
        v-for="index in 2"
        :key="index"
        :depressed="!isActiveIndex(index)"
        :color="isActiveIndex(index) ? 'primary' : 'secondary'"
        class="text-capitalize events-auto"
        width="175"
        style="transition: 0.5s"
        @click="logger(
          $event,
          isActiveIndex(index) ? 'ActiveButton' : 'InactiveButton',
          isActiveIndex(index),
        )"
        @contextmenu="logger(
          $event,
          isActiveIndex(index) ? 'ActiveButton' : 'InactiveButton',
          false,
        )"
      >
        Button {{ index }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import ProgressBar from '@/components/ProgressBar.vue';

const EVENT_TYPES = {
  click: 'leftClickDown',
  contextmenu: 'rightClickDown',
};

export default {
  name: 'MouseButtonTest',
  components: {
    ProgressBar,
  },
  data() {
    return {
      activeIndex: null,
      progress: 0,
      logs: [],
    };
  },
  mounted() {
    this.updateActiveIndex();
  },
  computed: mapGetters([
    'getExerciseTitle',
    'getNumberOfSuccessAttempts',
  ]),
  methods: {
    isActiveIndex(index) {
      return (index - 1) === this.activeIndex;
    },
    correctClickHandler() {
      this.incrementProgress();
      this.updateActiveIndex();

      if (this.progress === 100) {
        this.activeIndex = null;
        this.$store.commit('SAVE_LOG', {
          key: 'mouse_buttons_test',
          payload: this.logs,
        });

        this.$emit('next');
      }
    },
    updateActiveIndex() {
      this.activeIndex = Number(!this.activeIndex);
    },
    incrementProgress() {
      this.progress += (100 / this.getNumberOfSuccessAttempts);
    },
    logger(e, hit_target, correct) {
      this.logs.push({
        event_type: EVENT_TYPES[e.type],
        timestamp: Date.now(),
        x_coord: e.x,
        y_coord: e.y,
        viewport_width: window.innerWidth,
        viewport_height: window.innerHeight,
        hit_target,
        correct,
      });

      if (correct) this.correctClickHandler();
    },
  },
};
</script>
